<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? 'Edit Custom Field' : 'Add Custom Field' }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="max-width: 600px; margin: 0 auto">
    <div style="padding: 16px">
      <h2 class="input-section-header">Configure</h2>
      <div class="input-section-divider"></div>

      <app-custom-fields
        *ngIf="field"
        [customFields]="[field]"
        [placeholder]="'Ex: Favorite color'"
        [addCustomFieldButtonLabel]="'Add a custom ticket field'"
        [showDescription]="true"
        [hideAddAndDeleteButtons]="true"
        [showRequiredOption]="false"
        [editMode]="!!id"
        [readOnly]="false"
      >
      </app-custom-fields>
    </div>

    <div style="padding: 0 16px 16px 16px" *ngIf="field?.label">
      <h2 class="input-section-header">Preview</h2>
      <div class="input-section-divider"></div>

      <div class="preview-container" style="margin-top: 16px">
        <ion-card class="outline-card">
          <app-response-input [responseInputFields]="[field]" [showPublicOption]="false" layout="list">
          </app-response-input>
        </ion-card>
      </div>
    </div>

    <div style="padding: 0 16px 16px 16px">
      <h2 class="input-section-header">AI Options</h2>
      <div class="input-section-divider"></div>
      <ion-label class="input-label">
        Prefill Value on Status Change
        <ion-icon
          name="information-circle"
          class="icon-padded-left"
          ngxTippy
          data-tippy-content="When a ticket is updated to this status, or a downstream status, the AI will attempt to prefill this value."
        ></ion-icon>
      </ion-label>
      <button
        class="select-outline input-field fake-form-select"
        (click)="showSubStatusPopover($event)"
        [disabled]="isLoading"
        expand="block"
        fill="outline"
      >
        <span>
          <ion-icon
            *ngIf="selectedSubStatusDisplay?.icon"
            [name]="selectedSubStatusDisplay?.icon"
            [class]="selectedSubStatusDisplay?.iconClass"
            slot="start"
            style="margin: 0 5px 2px 0"
          ></ion-icon>
          <ion-label *ngIf="selectedSubStatusDisplay"
            >{{ selectedSubStatusDisplay.name }} ({{ selectedSubStatusDisplay.type }})</ion-label
          >
          <ion-label *ngIf="!selectedSubStatusDisplay">None</ion-label>
        </span>
        <ion-icon name="caret-down-outline" slot="end"></ion-icon>
      </button>
    </div>

    <div style="padding: 0 16px 16px 16px">
      <ion-label class="input-label">
        Prefill Prompt
        <ion-icon
          name="information-circle"
          class="icon-padded-left"
          ngxTippy
          data-tippy-content="Enter a prompt for the AI to use when prefilling this field. This will guide the AI in generating a relevant value."
        ></ion-icon>
      </ion-label>
      <ion-textarea
        class="input-field"
        [(ngModel)]="field.prefillPrompt"
        placeholder="e.g., Summarize the issue based on the initial customer message."
        [autoGrow]="true"
        rows="3"
      ></ion-textarea>
    </div>
  </div>
  <div style="padding: 0 16px 16px 16px" *ngIf="id && conversationsDataSource">
    <h2 class="input-section-header">Conversations Using This Field</h2>
    <div class="input-section-divider"></div>
    <ngx-datatable
      class="material datatable-row-borders datatable-row-top-aligned"
      [loadingIndicator]="isConversationsLoading"
      columnMode="force"
      paginated
      [dataSource]="conversationsDataSource"
      [limit]="10"
      [headerHeight]="50"
      [footerHeight]="50"
      rowHeight="auto"
      [scrollbarH]="true"
      [rows]="conversationsWithField"
      [reorderable]="false"
    >
      <ngx-datatable-column name="Conversation ID" prop="friendlyId" [width]="100">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <a [routerLink]="['/dashboard/inbox/all/conversations', row.id]" target="_blank"
            >#{{ row.friendlyId }} {{ row.title }}</a
          >
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Field Value" prop="ticketFieldValue" [minWidth]="200">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="suggested-field-value">
            {{ row.ticketFieldValue }}
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Feedback" prop="ticketFieldFeedback" [width]="180">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div *ngIf="row.ticketFieldFeedback !== null && row.ticketFieldFeedback !== undefined">
            {{ row.ticketFieldFeedback ? 'Approved' : 'Rejected' }}
          </div>
          <div *ngIf="row.ticketFieldFeedback === null || row.ticketFieldFeedback === undefined">
            <a
              (click)="showPrefillOption(row)"
              class="prefill-button"
              ngxTippy
              data-tippy-content="click to apply or reject prefill"
              ><ion-icon name="add-outline" class="padded-icon checkbox-icon"></ion-icon>add feedback</a
            >
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="AI Analysis" prop="prefillAnalysis" [minWidth]="250">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <!-- View mode -->
          <div *ngIf="row.prefillAnalysis && row.id !== editingRowId" class="prefill-analysis">
            <div class="analysis-actions">
              <a (click)="startEditingAnalysis(row)" class="edit-link">
                <ion-icon name="create-outline" class="padded-icon"></ion-icon>Edit
              </a>
              <span *ngIf="row.isSupportTeamMemberAnalysis" class="support-edited-badge">
                <ion-icon name="person-outline" class="padded-icon"></ion-icon>Edited by Support
              </span>
            </div>
            <div [innerHTML]="renderMarkdown(row.prefillAnalysis) | safeHtml"></div>
          </div>

          <!-- Edit mode -->
          <div *ngIf="row.id === editingRowId" class="edit-analysis-container">
            <app-tiptap-editor [(ngModel)]="editingAnalysis" placeholder="Enter analysis..." [enableLinkEditing]="true">
            </app-tiptap-editor>

            <div class="edit-actions">
              <ion-button size="small" fill="clear" (click)="cancelEditingAnalysis()" [disabled]="isSavingAnalysis">
                Cancel
              </ion-button>
              <ion-button size="small" (click)="saveAnalysis(row)" [disabled]="isSavingAnalysis || !editingAnalysis">
                Save
                <ion-spinner *ngIf="isSavingAnalysis" name="crescent" style="margin-left: 8px"></ion-spinner>
              </ion-button>
            </div>
          </div>

          <!-- States for when no analysis exists -->
          <div
            *ngIf="!row.prefillAnalysis && (row.ticketFieldFeedback === true || row.ticketFieldFeedback === false)"
            class="pending-analysis"
          >
            <ion-icon name="time-outline" class="padded-icon"></ion-icon> Analysis pending...
          </div>
          <div
            *ngIf="!row.prefillAnalysis && (row.ticketFieldFeedback === null || row.ticketFieldFeedback === undefined)"
            class="no-feedback"
          >
            <span>Add feedback for AI analysis</span>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Save
    <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
  </ion-button>
  <div>
    <ion-button
      fill="clear"
      color="dark"
      (click)="duplicate()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Duplicate"
      style="margin-left: 10px"
    >
      <ion-icon name="duplicate-outline"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      color="dark"
      (click)="delete()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Delete"
    >
      <ion-icon name="trash-outline"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
